<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات گواهی نامه</h5>

    <div>

      <form>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> شماره رسید </label>
            <input value="{{Calibration_Device.dsc}}" disabled type="text" class="form-control">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> نام دستگاه </label>
            <input value="{{Calibration_Device.device_name}}" disabled type="text" class="form-control">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> کد دستگاه </label>
            <input [(ngModel)]="Calibration_Device.device_code" name="device_code" placeholder="اینجا تایپ کنید ..."
              type="text" class="form-control">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> سریال دستگاه </label>
            <input [(ngModel)]="Calibration_Device.device_serial" name="device_serial" placeholder="اینجا تایپ کنید ..."
              type="text" class="form-control">
          </div>
        </div>

      </form>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Certificate Code </label>
            <input value="{{CertificateCode}}" disabled type="text" class="form-control">
          </div>

          <div class="form-group col-md-6">
            <app-DataEntityLabAddress [inner_Calibration_Device_Id]="Calibration_Device_Id"
              [inner_Calibration_Lab_Address]="Calibration_Device.labAdderss"
              (outter_selected_Lab_Address)="Set_LabAddress_click($event)">

            </app-DataEntityLabAddress>
          </div>


        </div>
      </form>

      <br />
      <hr />
      <br />

      <app-DataEntityCertificateNote [inner_Calibration_Device_Id]="Calibration_Device_Id">

      </app-DataEntityCertificateNote>

      <br />
      <hr />
      <br />

      <app-AddressLetterCertificate [inner_Calibration_Detail_Id]="Calibration_Device_Id">

      </app-AddressLetterCertificate>

      <br />
      <hr />
      <br />

      <form>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> واحد Nominal </label>
            <select class="custom-select" [(ngModel)]="unit_nominal" name="unit_nominal">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> MANUFACTURE </label>
            <input [(ngModel)]="Manufacture_txt" name="Manufacture_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> MODEL </label>
            <input [(ngModel)]="Model_txt" name="Model_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> TYPE </label>
            <select class="custom-select" [(ngModel)]="Type_txt" name="Type_txt">
              <option value="">انتخاب کنید</option>
              <option value="In Box">In Box</option>
              <option value="Without Box">Without Box</option>
            </select>
          </div>
        </div>

      </form>

      <form>

        <div class="row">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Zero Point (pHas) </label>
            <input [(ngModel)]="value1" name="value1" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> pH=10.0  at 25 C </label>
            <input [(ngModel)]="value2" name="value2" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Temperature Compensation Inaccuracy C </label>
            <input [(ngModel)]="value3" name="value3" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>



        </div>


      </form>


      <br />
      <hr />
      <br />


      <form [formGroup]="MainFormDataEntity">

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © before </label>
            <input formControlName="Temperature_Air_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Air_before().valid && get_Form_Temperature_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Tmperature of Air © before را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © after </label>
            <input formControlName="Temperature_Air_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Air_after().valid && get_Form_Temperature_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Tmperature of Air © after را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) before </label>
            <input formControlName="Humidity_Air_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Humidity_Air_before().valid && get_Form_Humidity_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Humidity of Air (%rH) before را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) after </label>
            <input formControlName="Humidity_Air_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Humidity_Air_after().valid && get_Form_Humidity_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Humidity of Air (%rH) after را وارد نمائید.</small>
          </div>


        </div>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) before </label>
            <input formControlName="Pressure_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Pressure_before().valid && get_Form_Pressure_before().touched"
              class="form-text text-muted MyErrorRedColor">Ambient Pressure (hPa) before را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) after </label>
            <input formControlName="Pressure_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Pressure_after().valid && get_Form_Pressure_after().touched"
              class="form-text text-muted MyErrorRedColor">Ambient Pressure (hPa) after را وارد نمائید.</small>
          </div>


        </div>


      </form>

      <br />
      <hr />
      <br />



    </div>

    <form>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> بارگذاری فایل پیوست : </label>
          <input type="file" #file_pdf>
        </div>
        <div class="form-group col-md-6">
          <img *ngIf="Procssing_Import2" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!Procssing_Import2" type="button" class="btn btn-info"
            (click)="upload_file_pdf(file_pdf.files)"> بارگذاری فایل پیوست <i class="fa fa-upload"></i></button>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> بارگذاری فایل : </label>
          <input type="file" #file_excel>
        </div>
        <div class="form-group col-md-6">
          <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!Procssing_Import" type="button" class="btn btn-warning"
            (click)="upload_file_excel(file_excel.files,1)"> بارگذاری فایل <i class="fa fa-upload"></i></button>
        </div>
      </div>
    </form>

    <br />
    <hr />
    <br />

    <div>

      <h5 class="card-title">Range / Resolution</h5>


      <form [formGroup]="ResolutionFormDataEntity" (submit)="Add_Resolution()">
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Min Rage </label>
            <input formControlName="range_min" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Max Rage </label>
            <input formControlName="range_max" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> SCALE DIVISION </label>
            <input formControlName="scale" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>
        </div>
        <button type="submit" [disabled]="!ResolutionFormDataEntity.valid" class="btn btn-success"
          style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن Range / Resolution </button>
      </form>

      <div class="table-responsive" *ngIf="DataList_Resolution.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #39411b; color: white;">
            <tr>
              <th>#</th>
              <th>Min Range</th>
              <th>Max Range</th>
              <th>SCALE DIVISION</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Resolution">
              <td>{{DataList_Resolution.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.range_min}}</td>
              <td class="EnglishClm">{{item.range_max}}</td>
              <td class="EnglishClm">{{item.scale}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                      <a style="cursor: pointer;" class="dropdown-item"
                        (click)="Delete_Resolution(DataList_Resolution.indexOf(item))"><i class="fa fa-remove"></i>
                        حذف
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>


        </table>
      </div>

    </div>

    <br />
    <hr />
    <br />

    <div class="table-responsive" *ngIf="Nominal_Value_List.length>0">

      <table class="mb-0 table table-bordered table-3 text-center table-striped">

        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Reference Value</th>
            <th>Uncertainty</th>
            <th>Converge Factor</th>

          </tr>
        </thead>
        <tbody>

          <ng-container *ngFor="let item of Nominal_Value_List">



            <tr>

              <td>{{Nominal_Value_List.indexOf(item)+1}}</td>
              <td>{{item.reference_Value}}</td>
              <td>{{item.uncertainty}}</td>
              <td>{{item.converage}}</td>
            </tr>


          </ng-container>

        </tbody>

      </table>

    </div>


    <div>

      <br />
      <hr />
      <br />
      <button *ngIf="InProccessing" type="button" class="btn btn-info" style="margin-left: 5px;"> سیستم در حال ساخت
        گواهی نامه می باشد. لطفا صبر نمائید ... <i class="fa fa-spin fa-spinner"></i> </button>

      <button *ngIf="!InProccessing && !CertificateCode" type="button"
        (click)="onSubmit(templateCode,templateCodeSerialDevice,0)" class="btn btn-success" style="margin-left: 5px;"><i
          class="fa  fa-plus-circle"></i> ثبت اطلاعات گواهی نامه </button>
      <button *ngIf="!InProccessing && CertificateCode" type="button"
        (click)="onSubmit(templateCode,templateCodeSerialDevice,0)" class="btn btn-info" style="margin-left: 5px;"><i
          class="fa  fa-edit"></i>
        ویرایش
        اطلاعات گواهی نامه </button>

      <a target="_blank" *ngIf="!InProccessing && CertificateCode && CertificateUrlPdf" href="{{CertificateUrlPdf}}"
        style="margin-left: 5px;" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> فایل گواهی نامه </a>

      <button routerLink="/KartableInbox" *ngIf="!InProccessing" type="button" style="margin-left: 5px;"
        class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>

    </div>

  </div>
</div>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> کد گواهی نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>کد گواهی نامه فرم کالبیراسیون کد گواهی نامه <b>'{{CertificateCode}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCodeSerialDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> هشدار </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CodeSerial.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <h6> {{modalRef_CodeSerial_Title}} </h6>

  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="onSubmit_Code(templateCode,templateCodeSerialDevice,1)">بله،
      مورد تایید است</button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CodeSerial.hide()">خیر</button>
  </div>
</ng-template>